import { useAtomValue } from "jotai";
import type { FC } from "react";
import { useNotificationCenterRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { NotificationsTabsLayout } from "web_myplann/Dashboard/Pages/NotificationsTabsLayout";
import { NotificationCenterPage } from "web_myplann/NotificationCenter/Pages/NotificationCenterPage";
import { rightsState } from "web_myplann/Shared/State/rightsAtom";

export const NotificationsRouteSwitch: FC = () => {
	const isPending = useAtomValue(rightsState) === undefined;
	const hasNotificationCenterRight = useNotificationCenterRightOptional();

	// isPending holds the gate even during an offline-paused first fetch, so the legacy layout doesn't rewrite the URL to /notifications/unread.
	if (isPending) {
		return null;
	}

	return hasNotificationCenterRight ? (
		<NotificationCenterPage />
	) : (
		<NotificationsTabsLayout />
	);
};
